import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { App } from './App';
import './index.css';

// ── Mock mode ─────────────────────────────────────────────────────────────────
// Activo cuando VITE_MOCK=true en .env.development
// Para desactivar: cambiar a VITE_MOCK=false o eliminar la variable
if (import.meta.env.VITE_MOCK === 'true') {
  const { initMocks } = await import('./mocks/setup');
  initMocks();
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: 1,
    },
  },
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>
);
